import { ETItemKind } from './types';

/**
 * Single source of truth for the human label of each timeline item kind.
 *
 * Previously duplicated as a local `TYPE_LABEL` map in HoverTooltip and in the
 * feature layer's TimelineInspectorRail. Consolidated here, next to the
 * `ETItemKind` union it keys off, so a new kind can't drift out of sync.
 *
 * NOTE: still English-only. This timeline surface is not yet threaded through
 * i18n (`t()`); when it is, this map is the one place to swap.
 */
export const KIND_LABEL: Record<ETItemKind, string> = {
  MESSAGE: 'Message',
  TASK: 'Task',
  AUTOMATION: 'Automation'
};
